(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/product-base/assets/javascripts/tabs.js') >= 0) return;  svs.modules.push('/components/components/product-base/assets/javascripts/tabs.js'); "use strict";

svs.components.productBase = svs.components.productBase || {};

svs.components.productBase.Tabs = function (options, gameColumnElement) {
  var self = this;

  function init() {
    var tabs = [];
    var tabsOptions = {
      el: $(options.el).find('.js-product-base-tabs-tabs'),
      navItemsEl: $(options.el).find('.js-product-base-tabs-nav'),
      navContentEl: $(options.el).find('.js-product-base-tabs-content'),
      useSplitTab: true,
      startIndex: 2,
      navCssClass: "tabs-300 tabs-".concat(options.generalSettings.branding),
      contentCssClass: 'bg-white',
      slideOnDrag: false,
      solidNav: true,
      widgetResizeMode: true,
      defaultScroll: options.useDefaultScroll.isActive,
      stickyNav: options.useDefaultScroll.stickyNav,
      fixedStartTab: svs.core.detect.formfactor.mobile()
    };

    if (options.content.useGameColumnAsTab) {
      tabs.push({
        id: 'coupon',
        title: 'Spela',
        el: gameColumnElement,
        isLoaded: true
      });
    }

    var isFirstActiveTab = true;
    var columnClass = svs.core.detect.feature('ft-maltipset-direct-play') ? 'widget-area-half-column' : 'widget-area-two-thirds-column';

    for (var i = 0; i < options.tabs.length; i++) {
      if (options.tabs[i].active) {
        var startpageTab = "startPageTab".concat(i, "_0");
        var safeString = Handlebars.helpers.widgetArea({
          hash: {
            name: startpageTab,
            class: columnClass
          }
        });
        var tabContent = "<div>".concat(safeString ? safeString.string : '', "</div>");
        tabs.push({
          id: options.tabs[i].anchor,
          title: options.tabs[i].label,
          el: isFirstActiveTab ? tabContent : null,
          tabName: startpageTab,
          anchor: options.tabs[i].anchor,
          href: "?flik=".concat(options.tabs[i].anchor),
          isLoaded: isFirstActiveTab,
          useSwiper: typeof options.tabs[i].useSwiper === 'boolean' ? options.tabs[i].useSwiper : true
        });
        isFirstActiveTab = false;
      }
    }

    tabsOptions.tabs = tabs;
    var tabsComponent = new svs.components.Tabs(tabsOptions);
    tabsComponent.on('change', function (tab) {
      if (svs.content && svs.content.simple_article) {
        svs.content.simple_article.hideSummary(null, $(tab.el).parents('.js-product-base-tabs-content'), true);
      }

      if (!tab.tab.isLoaded) {
        tab.tab.isLoaded = true;
        svs.components.loader.show();
        var tabEl = $(tab.el);
        svs.core.widget_area.loadArea(tab.tab.tabName, columnClass, function (safeString) {
          svs.components.loader.hide();

          if (tabEl.find('.js-swiper-container ').length > 0) {
            tabEl.find('.js-swiper-container ').html(safeString ? safeString.string : '');
          } else {
            tabEl.html(safeString ? safeString.string : '');
          } 


          var firstImage = tabEl.find('.js-responsive-image').first();
          setTimeout(function () {
            firstImage.hide().show();
          }, 100);
        });
      } 


      var url = svs.utils.url.updateQueryStringParameter(window.location.search, 'flik', tab.tab.anchor); 

      if (url === '?' || url === '&') {
        history.replaceState(null, 'spela', window.location.pathname);
      } else {
        history.replaceState(null, tab.tab.title || tab.tab.content, url);
      }

      self.trigger('change', tab.index);
      tabsComponent.resize();
    });
    svs.utils.url.refreshQueryString();
    var tabAnchor = svs.utils.url.queryString.flik;

    if (window.location.search && window.location.search.indexOf('flik') >= 0 && tabAnchor) {
      setActiveTab(tabAnchor);
    }
  }

  function setActiveTab(tabAnchor) {
    $(".js-product-base-tabs-nav .js-slider-slide[data-anchor=".concat(tabAnchor.toLowerCase(), "]")).click();
  }

  self = new svs.core.Events({});
  init();
  return self;
};
 })(window);